<template>
  <div>
    <v-row v-for="subgroup in subgroups" :key="subgroup.uuid" no-gutters>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card class="elevation-0 my-2">
          <v-card-actions>
            <div class="ml-10">
              <v-icon class="mr-2 mb-1">mdi-account-multiple</v-icon
              ><span class="subtitle-1 grey--text text--darken-1">
                {{ subgroup.name }}
              </span>
              <v-chip outlined class="ml-2">{{
                $t("components.miscellaneous.subBrandDetails.range")
              }}</v-chip>
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-btn
                color="primary"
                text
                @click="setAddUser(subgroup, 'invite')"
                v-if="subgroup.details && canUserAddEditGroupDetails(subgroup)"
                ><v-icon class="mr-2">mdi-account-plus</v-icon
                >{{ $t("components.miscellaneous.subBrandDetails.addUser") }}
              </v-btn>
              <v-btn
                @click="editGroup(subgroup, 'details')"
                v-if="
                  canAccessGroup(subgroup) &&
                  canUserAddEditGroupDetails(subgroup)
                "
                icon
                color="primary"
                ><v-icon>mdi-pencil</v-icon></v-btn
              >
              <v-btn
                class="mr-4"
                :loading="subgroup.loading"
                @click="
                  showGroupDetails(subgroup) && canUserSeeGroupDetails(subgroup)
                "
                icon
                color="primary"
                ><v-icon v-if="!subgroup.details">mdi-chevron-down </v-icon>
                <v-icon v-else>mdi-chevron-up</v-icon></v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
        <v-card flat class="mt-0 pt-0 mb-3" v-if="subgroup.details">
          <group-details
            class="ml-9"
            :group-uuid="subgroup.uuid"
            :show-add-user-range-form="subgroup.showAddUserRangeForm"
            :access="
              canAccessGroup(subgroup) && canUserAddEditGroupDetails(subgroup)
            "
            ref="groupDetails"
            :show-add-range="false"
          ></group-details>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="subgroups.length !== 0">
      <sub-brand-details
        v-for="(subgroup, ind) in subgroups"
        :key="ind"
        :subgroups="subgroup.subgroups"
      ></sub-brand-details>
    </div>
  </div>
</template>

<script>
import GroupDetails from "@/components/miscellaneous/GroupDetails";
import SubBrandDetails from "@/components/miscellaneous/SubBrandDetails.vue";
import restrictions from "@/utils/restrictions.js";

export default {
  name: "sub-brand-details",
  components: {
    GroupDetails,
    SubBrandDetails,
  },
  props: {
    subgroups: {
      type: Array,
      default: Array,
    },
  },
  data: () => ({
    loading: true,
  }),
  created() {},
  methods: {
    canUserSeeGroupDetails(subgroup) {
      return restrictions.canUserSeeGroupDetails(subgroup.my_permissions);
    },
    canUserAddEditGroupDetails(subgroup) {
      return restrictions.canUserAddEditGroupDetails(subgroup.my_permissions);
    },
    setAddUser(subgroup, event) {
      subgroup.showAddUserRangeForm =
        subgroup.showAddUserRangeForm === event ? "" : event;
      this.$forceUpdate();
    },
    showGroupDetails(subgroup) {
      if (subgroup.details) {
        subgroup.details = false;
        this.$forceUpdate();
        return;
      }

      subgroup.details = true;
      this.$forceUpdate();
    },

    canAccessGroup(group) {
      return group.my_permissions.groups_permission !== "NONE";
    },

    editGroup(group, tab) {
      this.$router.push({
        name: "groups",
        params: { brandId: group.uuid, tab: tab },
      });
    },
  },
};
</script>
